function getStacksProvider() {
  return window.StacksProvider || window.BlockstackProvider;
}
function isStacksWalletInstalled() {
  return !!getStacksProvider();
}

export { getStacksProvider, isStacksWalletInstalled };
//# sourceMappingURL=utils.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@stacks/connect/dist/utils.esm.js
// module id = /I/t
// module chunks = 6